import { PostComment } from "@/components/Ticket/MessageInputBox";
import { axios } from '@/lib/axios';

interface GetTicketsParams {
  customer_id: number;
  tab_status?: string | null;
}

export const getTickets = (params: GetTicketsParams) => {
  return axios.get('/api/v1/customers/getTickets', {
    params
  })
}


export const postComment = (postData: PostComment) => {
  return axios.post('/api/v1/dataTickets/postComment', postData)
}

export const getFormInputs = () => {
  return axios.get('/api/v1/customers/getFormInputs');
}

interface SubmitTicketData {
  [key: string]: string | {
    original_filename: string;
    file_content: string;
  }[];
}

export const postTicket = (data: SubmitTicketData) => {
  return axios.post('/api/v1/customers/postTicket', data);
}

interface SearchTicketParams {
  keyword?: string | null;
}

export const searchTicket = (params: SearchTicketParams) => {
  return axios.get('/api/v1/customers/searchTickets', {
    params
  })
}

interface CancelScheduledMailParams {
  data_ticket_comment_id: number;
}

export const cancelScheduledMail = (params: CancelScheduledMailParams) => {
  return axios.post("/api/v1/dataTickets/cancelScheduledMail", params);
};